import { registerApplication, start } from "single-spa";

registerApplication(
  "api-docs",
  () => import("docs"),
  (location) => location.pathname.startsWith("/")
);

start();
